/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  AgileticsSamlResponseDto,
  ChannelUserModelDto,
  CompanyLoginBffRequestDto,
  CompanyLoginBffResponseDto,
  CompanyLoginRequestDto,
  CompanyLoginResponseDto,
  ErrorHttpContentDto,
  GetBffLoginUrlRequestDto,
  GetBffLoginUrlResponseDto,
  SsoViaUisRequestDto,
  SsoViaUisResponseDto,
  UisLoginUrlRequestDto,
  UisLoginUrlResponseDto,
  UserCompanyInformationCollectionDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AuthenticationClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationUisLoginUrl
   * @summary Gets a UisLoginUrlResponse.
   * @request POST:/Authentication/UisLoginUrl
   */
  authenticationUisLoginUrl = (data: UisLoginUrlRequestDto, params: RequestParams = {}) =>
    this.http.request<UisLoginUrlResponseDto, ErrorHttpContentDto>({
      path: `/Authentication/UisLoginUrl`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationBffLoginUrl
   * @summary Gets a GetBffLoginUrlResponse.
   * @request POST:/Authentication/BffLoginUrl
   */
  authenticationBffLoginUrl = (data: GetBffLoginUrlRequestDto, params: RequestParams = {}) =>
    this.http.request<GetBffLoginUrlResponseDto, ErrorHttpContentDto>({
      path: `/Authentication/BffLoginUrl`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationSsoViaUis
   * @summary Gets a SsoViaUisResponse.
   * @request POST:/Authentication/SsoViaUis
   */
  authenticationSsoViaUis = (data: SsoViaUisRequestDto, params: RequestParams = {}) =>
    this.http.request<SsoViaUisResponseDto, ErrorHttpContentDto>({
      path: `/Authentication/SsoViaUis`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationUisMobileRedirect
   * @summary Takes in fiId, code, and state and returns UIS mobile redirect URI.
   * @request GET:/Authentication/UisMobileRedirect/{fiId}
   */
  authenticationUisMobileRedirect = (
    fiId: string,
    query?: {
      code?: string;
      state?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<any, string | ErrorHttpContentDto>({
      path: `/Authentication/UisMobileRedirect/${fiId}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationCompanyLogin
   * @summary Gets a CompanyLoginResponse.
   * @request POST:/Authentication/CompanyLogin
   */
  authenticationCompanyLogin = (data: CompanyLoginRequestDto, params: RequestParams = {}) =>
    this.http.request<CompanyLoginResponseDto, ErrorHttpContentDto>({
      path: `/Authentication/CompanyLogin`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationCompanyLoginBff
   * @summary Gets a CompanyLoginBffResponse.
   * @request POST:/Authentication/CompanyLoginBff
   */
  authenticationCompanyLoginBff = (data: CompanyLoginBffRequestDto, params: RequestParams = {}) =>
    this.http.request<CompanyLoginBffResponseDto, ErrorHttpContentDto>({
      path: `/Authentication/CompanyLoginBff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationAgiletics
   * @summary Gets a AgileticsSamlResponse.
   * @request POST:/Authentication/Agiletics
   */
  authenticationAgiletics = (params: RequestParams = {}) =>
    this.http.request<AgileticsSamlResponseDto, ErrorHttpContentDto>({
      path: `/Authentication/Agiletics`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationCurrentUser
   * @summary Gets current authentication user information.
   * @request GET:/Authentication/CurrentUser
   */
  authenticationCurrentUser = (params: RequestParams = {}) =>
    this.http.request<ChannelUserModelDto, ErrorHttpContentDto>({
      path: `/Authentication/CurrentUser`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationGetCurrentUisUserCompanies
   * @summary Gets the user-company information for the currently authenticated user.
   * @request GET:/Authentication/GetCurrentUisUserCompanies
   */
  authenticationGetCurrentUisUserCompanies = (params: RequestParams = {}) =>
    this.http.request<UserCompanyInformationCollectionDto, ErrorHttpContentDto>({
      path: `/Authentication/GetCurrentUisUserCompanies`,
      method: "GET",
      format: "json",
      ...params,
    });
}
